import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/Image';
import styles from './styles/styles.module.scss';

import LogoImage from '../../../../assets/images/icons/cuttlefish/logo.svg';
import ActiveProBadge from '../../../../assets/images/icons/cuttlefish/activeProBadge.svg';
import ProBadge from '../../../../assets/images/icons/cuttlefish/proBadge.svg';

const Logo = ({ showProBadge, isProBadgeActive, proBadgeLink, logoLink }) => {
  const proBadge = showProBadge ? (
    <a href={proBadgeLink}>
      <Image className={styles.proBadge} src={isProBadgeActive ? ActiveProBadge : ProBadge} />
    </a>
  ) : (
    ''
  );
  return (
    <div className={styles.container}>
      <a href={logoLink}>
        <Image className={styles.logo} src={LogoImage} />
      </a>
      {proBadge}
    </div>
  );
};

Logo.defaultProps = {
  showProBadge: false,
  isProBadgeActive: false
};

Logo.propTypes = {
  showProBadge: PropTypes.bool,
  isProBadgeActive: PropTypes.bool,
  proBadgeLink: PropTypes.string.isRequired,
  logoLink: PropTypes.string.isRequired
};

export default Logo;
